import React from "react"
import PropTypes from "prop-types"
import MenuIcon from "react-icons/lib/md/more-horiz"

import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton/IconButton"
import Menu from "@material-ui/core/Menu/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import Typography from "@material-ui/core/Typography/Typography"
import { translate } from "react-i18next"
import flow from "lodash/flow"

import styles from "./styles"

class DropDownMenu extends React.Component {
    state = {
        anchorEl: null,
    }

    openMenu = (event) => {
        this.setState({ anchorEl: event.currentTarget })
    }

    closeMenu = () => {
        this.setState({ anchorEl: null })
    }

    render() {
        const {
            t,
            classes,
            id,
            items,
            icon,
        } = this.props
        const open = Boolean(this.state.anchorEl)

        return (
            <div>
                <IconButton
                    aria-owns={open ? id : null}
                    aria-haspopup="true"
                    aria-label={t("main:menu")}
                    onClick={this.openMenu}
                    color="inherit"
                    className={classes.iconButton}
                >
                    {icon}
                </IconButton>
                <Menu
                    id={id}
                    classes={{
                        paper: classes.menu,
                    }}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={open}
                    onClose={this.closeMenu}
                >
                    { items.map(item => (
                        <MenuItem
                            className={classes.menuItem}
                            key={item.id}
                            onClick={() => {
                                this.closeMenu()
                                item.action()
                            }}
                        >
                            <Typography variant="caption">{item.title}</Typography>
                        </MenuItem>
                    ))}
                </Menu>
            </div>
        )
    }
}

DropDownMenu.propTypes = {
    /* Unique identifier string in the page */
    classes: PropTypes.object.isRequired,
    icon: PropTypes.node,
    id: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        action: PropTypes.func.isRequired,
    })).isRequired,
}

DropDownMenu.defaultProps = {
    icon: <MenuIcon />,
}

export default flow(
    withStyles(styles),
    translate()
)(DropDownMenu)
